import { SpeechSynthesisConfig } from './types';

/**
 * デフォルトの音声合成設定
 */
export const DEFAULT_SPEECH_CONFIG: SpeechSynthesisConfig = {
  enableSplitting: true,
  splitting: {
    enabled: true,
    minLength: 50,
    segmentMinLength: 10,
    delimiters: /[。！？]/,
  },
  delays: {
    queueProcessing: 50,
    errorRecovery: 100,
    segmentTransition: 100,
  },
  speakingRate: 1.25,
};

/**
 * パフォーマンス最適化済み設定
 */
export const OPTIMIZED_SPEECH_CONFIG: SpeechSynthesisConfig = {
  enableSplitting: true,
  splitting: {
    enabled: true,
    minLength: 40,
    segmentMinLength: 8,
    delimiters: /[。！？、]/,
  },
  delays: {
    queueProcessing: 30,
    errorRecovery: 50,
    segmentTransition: 50,
  },
  speakingRate: 1.25,
};

/**
 * デバッグ用設定（分割無効）
 */
export const DEBUG_SPEECH_CONFIG: SpeechSynthesisConfig = {
  enableSplitting: false,
  splitting: {
    enabled: false,
    minLength: 100,
    segmentMinLength: 20,
    delimiters: /[。！？]/,
  },
  delays: {
    queueProcessing: 100,
    errorRecovery: 200,
    segmentTransition: 200,
  },
  speakingRate: 1.25,
};
